import { queryOptions } from '@tanstack/react-query';

import { organisationApi } from '../apis/organisation';
import { GetValuesParams } from '../types/dto';

import { Filters, Globals } from '@data-access';

export const organisationsQueries = (global: Globals) => ({
  all: () => [global, 'organisations'],

  lists: () => [...organisationsQueries(global).all(), 'list'],
  list: (filters: Filters) =>
    queryOptions({
      queryKey: [...organisationsQueries(global).lists(), filters],
      queryFn: () => organisationApi.getAll(filters),
    }),

  details: () => [...organisationsQueries(global).all(), 'detail'],
  detail: (id: number) =>
    queryOptions({
      queryKey: [...organisationsQueries(global).details(), id],
      queryFn: () => organisationApi.getOneById(id),
    }),

  values: (data: GetValuesParams) =>
    queryOptions({
      queryKey: [...organisationsQueries(global).all(), 'values', data],
      queryFn: () => organisationApi.getValues(data),
    }),
});
